import { useGetBadgeDetails } from "../form/dataloader";
import React from "react";
import ApiBadgeDetails from "../../../../shared/types/ApiBadgeDetails";
import Button from "../../../../shared/components/button";
import OpenLinkInNewTab from "../../../../shared/form/core/link";
import { useCopies } from "../../../../shared/hooks/useCopies";
import Icon from "assets/icons";

export default function ParticipantBadgeDetails({ registrationParticipantId }: { registrationParticipantId: string }) {
  const badgeRef = React.useRef<HTMLDivElement>(null);
  const { data: badgeDetails = [], refetch: retryBadgeDetails } = useGetBadgeDetails(registrationParticipantId);
  const eventBadgeDetails: ApiBadgeDetails | undefined = React.useMemo(() => badgeDetails?.[0], [badgeDetails]);

  React.useEffect(() => {
    badgeRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center"
    });
  }, [badgeDetails]);

  const hasBadgeInformation = React.useMemo(() => {
    return Boolean(eventBadgeDetails?.badgeReferenceId);
  }, [eventBadgeDetails]);

  return (
    <div className="reg-badge-wrapper printHide">
      <div className="flex--2 flexHCenter flexVTop" ref={badgeRef}>
        {hasBadgeInformation ? (
          <ShowBadgeInformation eventBadgeDetails={eventBadgeDetails} />
        ) : (
          <RetryBadgeDetails retryCallBack={retryBadgeDetails} />
        )}
      </div>
    </div>
  );
}

function ShowBadgeInformation({ eventBadgeDetails }: { eventBadgeDetails: ApiBadgeDetails }) {
  const copies = useCopies();
  return (
    <React.Fragment>
      <div className="reg-badge__view--qr-code ">
        <h3>{copies.get("qr.code.info")}</h3>
        <OpenLinkInNewTab
          url={eventBadgeDetails.qrCodeUrl}
          title={eventBadgeDetails.qrCodeUrl}
          label={copies.get("qr.code.label")}
          icon={<Icon.QRCode />}
        />
      </div>
      {eventBadgeDetails.badgeUrl && (
        <React.Fragment>
          <div className="reg-badge__view--badge-details ">
            <h3>{copies.get("badge.details.info")}</h3>
            <OpenLinkInNewTab
              url={eventBadgeDetails.badgeUrl}
              title={eventBadgeDetails.badgeUrl}
              label={copies.get("badge.details.label")}
              icon={<Icon.Badge />}
            />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

function RetryBadgeDetails({ retryCallBack }: { retryCallBack: () => void }) {
  const copies = useCopies();
  return (
    <div className="reg-badge__retry">
      <h3>{copies.get("badge.details.retry.info")}</h3>
      <Button icon={<Icon.Refresh />} label={copies.get("retry")} onClick={retryCallBack} isOutline />
    </div>
  );
}
